import Repository from "@/repository";

const defaultLead = {
  created_at: "",
  name: "",
  project_type: "",
  project_status: "",
  attraction_channel: "",
  payment_type: "",
  lead_qualification: "",
  estimated_time: 0,
  estimated_cost: 0,
  attachments: [],
  client: {
    name: "",
    phone_number: "",
    additional_phone_number: "",
    location: "",
    company: "",
    email: "",
    web_site: "",
    note: "",
  },
  author: null
}

export default {
  state: {
    leads: [],
    lead: JSON.parse(JSON.stringify(defaultLead)),
    totalPages: 1,
    thisPage: 1
  },
  actions: {
    async getLeads({ commit }, params) {
      const data = {
        attraction_channel: params.attraction_channel,
        created_after: params.from,
        created_before: params.before,
        page: params.page,
        payment_type: params.payment_type,
        project_status: params.project_status,
        project_type: params.project_type,
        lead_qualification: params.lead_qualification,
        search: params.search,
        size: 20
      };
      if (!params.isNotLoad) {
        commit("setIsLoader", true);
      }

      const { value, error } = await Repository.LeadsActions.get(data)
      if (!error) {
        commit("setLeads", value.data)
        commit("setTotalPages", value.total_pages)
        commit("setThisPage", value.page)
      }
      commit("setIsLoader", false);
    },
    async getLead({ commit }, id) {
      commit("setIsLoader", true);
      const { value, error } = await Repository.LeadsActions.getOne(id)
      if (!error) {
        commit("setLead", value)
        value.attachments.forEach(i => commit("setFiles", i))
      }
      commit("setIsLoader", false);
    },
    async createLead({ commit, state }) {
      commit("setIsLoader", true);
      if (!state.lead.estimated_time) {
        delete state.lead.estimated_time
      }
      if (!state.lead.estimated_cost) {
        delete state.lead.estimated_cost
      }

      const { value, error } = await Repository.LeadsActions.create(state.lead)
      if (error) {
        commit("setErrors", error)
        commit("setIsLoader", false);
        return false
      }
      commit("resetLead")
      commit("setFiles", null);
      commit("setIsLoader", false);
      return true
    },
    async updateLead({ commit, state }) {
      commit("setIsLoader", true);
      const { error } = await Repository.LeadsActions.update(state.lead)
      if (error) {
        commit("setErrors", error)
        commit("setIsLoader", false);
        return false
      }
      commit("setFiles", null);
      commit("setIsLoader", false);
      return true
    },
    async deleteLead({ commit }, id) {
      commit("setIsLoader", true);
      const { value, error } = await Repository.LeadsActions.delete(id)
      commit("setIsLoader", false);
    },
  },
  mutations: {
    setLeadsField(state, { field, value }) {
      if (field.split(".").length > 1) {
        if (
          !(field.split(".")[0] in state.lead) ||
          state.lead[field.split(".")[0]] === null
        ) {
          state.lead[field.split(".")[0]] = {};
        }
        state.lead[field.split(".")[0]][field.split(".")[1]] = value;
      } else {
        state.lead[field] = value
      }
    },
    setLeads(state, value) {
      state.leads = value
    },
    setLead(state, value) {
      state.lead = value
    },
    resetLead(state) {
      state.lead = JSON.parse(JSON.stringify(defaultLead))
    },
    setTotalPages(state, value) {
      state.totalPages = value
    },
    setThisPage(state, value) {
      state.thisPage = value
    },
    deleteFileFromLead(state, id) {
      let index = ""
      state.leads.forEach((i, idx) => {
        i.attachments.forEach(j => {
          if (j.id === id) {
            index = idx
          }
        })
      })
      const lead = state.leads[index]
      lead.attachments = lead.attachments.filter(i => i.id !== id)
      state.leads.splice(index, 1, lead);
    },
    removeNotificationFromLead(state, id) {
      state.lead.notifications = state.lead.notifications.filter(i => i.id !== id)
    },
    addNotificationToLead(state, data) {
      state.lead.notifications.unshift(data)
    }
  },
};
